import { cva } from 'class-variance-authority'

import { CLSize } from '~/components/component-library'
import { sizeMap } from '~/components/component-library/NetworkLogo/util'

export const networkDisplayStyles = cva('', {
  variants: {
    layout: {
      standard: 'flex min-w-0 items-center gap-2 text-primary',
      'inline-text': 'whitespace-nowrap',
    },
    size: {
      small: '',
      base: '',
    },
  },
  compoundVariants: [
    { layout: 'standard', size: 'small', class: 'text-sm' },
    { layout: 'standard', size: 'base', class: 'text-base' },
  ],
  defaultVariants: {
    layout: 'standard',
    size: 'base',
  },
})

// The NetworkLogo icon step behind each CL size: 20px at small and 24px at
// base, matching the image sizes TokenDisplay and UserDisplay use so mixed
// rows (e.g. the token selector) line up.
export const LOGO_SIZE: Record<CLSize, keyof typeof sizeMap> = {
  small: 'ml',
  base: 'lg',
}
